<mat-tab-group>
  <mat-tab *ngFor="let tab of field.fieldGroup" [label]="tab.templateOptions.label">
    <div class="scrollable-tab-content">
      <formly-field [field]="tab"></formly-field>
    </div>
  </mat-tab>
</mat-tab-group>
